import { useContext } from 'react'
import { UserContext, UserTypes } from 'context/UserContext'
import { IconUser } from 'components/icons'
import { Dropdown } from 'antd'

function TopbarProfile() {
  const [, dispatch] = useContext(UserContext)

  const signOut = () => {
    dispatch({ type: UserTypes.SIGN_OUT })
  }

  return (
    <div className="topbar__profile" data-testid="topbar-profile-trigger">
      <Dropdown
        dropdownRender={() => (
          <div className="topbar__profile__menu">
            <ul>
              <li data-testid="logout-button" onClick={signOut}>
                Keluar
              </li>
            </ul>
          </div>
        )}
        placement="bottomLeft"
        trigger={['click']}
      >
        <button className="bg-gray-200 border-gray-200">
          <IconUser color="#555555" />
        </button>
      </Dropdown>
    </div>
  )
}

export default TopbarProfile
